import { Link } from "react-router-dom";
import { Mail, Phone, FileText } from "lucide-react";
import { OFFICE_EMAIL, OFFICE_PHONE, OFFICE_PHONE_TEL } from "@/data/content";

export default function MobileBar() {
  return (
    <nav
      data-testid="mobile-contact-bar"
      aria-label="Quick contact"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-gold/25 bg-navy/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md md:hidden"
    >
      {OFFICE_PHONE ? (
        <a data-testid="mobile-contact-call-btn" href={`tel:${OFFICE_PHONE_TEL}`} aria-label={`Call office at ${OFFICE_PHONE}`} className="flex flex-col items-center gap-1 py-3 text-ivory/70">
          <Phone size={16} className="text-gold" />
          <span className="font-mono text-[9px] uppercase tracking-[0.25em]">Call</span>
        </a>
      ) : (
        <span data-testid="mobile-contact-call-btn" aria-label="Call office — number available on request" className="flex flex-col items-center gap-1 py-3 text-ivory/30">
          <Phone size={16} />
          <span className="font-mono text-[9px] uppercase tracking-[0.25em]">Call</span>
        </span>
      )}
      <a data-testid="mobile-contact-email-btn" href={`mailto:${OFFICE_EMAIL}`} aria-label="Email office" className="flex flex-col items-center gap-1 border-x border-ivory/10 py-3 text-ivory/70">
        <Mail size={16} className="text-gold" />
        <span className="font-mono text-[9px] uppercase tracking-[0.25em]">Email</span>
      </a>
      <Link data-testid="mobile-contact-enquiry-btn" to="/contact#matter-intake" aria-label="Submit an enquiry" className="flex flex-col items-center gap-1 py-3 text-ivory/70">
        <FileText size={16} className="text-gold" />
        <span className="font-mono text-[9px] uppercase tracking-[0.25em]">Enquiry</span>
      </Link>
    </nav>
  );
}
